import { MarketModalPartial } from '@market/react';
import React, { ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from 'store/modalSlice';

export const enum ModalSize {
  Small = 'marketFullWidthModal:w-[460px]',
}

type Props = {
  titleElementId?: string;
  children: ReactNode;
  hideClose?: boolean;
  onClose?: (() => void) | (() => Promise<void>);
  size?: ModalSize;
  title?: string;
  className?: string;
};

const BaseModal: React.FC<Props> = (props) => {
  const dispatch = useDispatch();

  const close = () => {
    props.onClose?.();
    dispatch(closeModal());
  };

  return (
    <MarketModalPartial
      aria-modal
      aria-labelledby={props.titleElementId || undefined}
      trapFocus
      className={`${props.className || 'top-auto'} ${
        props.size?.toString() || ''
      }`}
      onMarketDialogDismissed={close}
      {...(props.title && { title: props.title })}
    >
      <main>{props.children}</main>
    </MarketModalPartial>
  );
};

export default BaseModal;
